import styles from './InputSelect.module.css';

export default function InputSelect({ name, label, value, onChange, options, error, onFocus, onBlur, placeholder }) {
    return (
        <div className={styles.inputContainer}>
            <label className={styles.label} htmlFor={name}>{label}</label>
            <select
                name={name}
                className={`${styles.select} ${error ? styles.error : ''} ${!value ? styles.placeholder : ''}`}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
            >
                <option value="" className={styles.placeholder}>{placeholder || "Select"}</option>
                {options.map(option => (
                    <option key={option.value} value={option.value} className={styles.option}>
                        {option.label}
                    </option>
                ))}
            </select>
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
}